import React from "react";
import { FaWhatsapp } from "react-icons/fa"; 
import "./WhatsappButton.css"; 

const WhatsappButton = () => {
  const whatsappLink = "https://wa.me/5591985980703"; 

  return (
    <a href={whatsappLink} className="whatsapp-button" target="_blank" rel="noopener noreferrer" aria-label="Fale no WhatsApp">
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsappButton;
